import {useState, useEffect, useRef} from "preact/compat";
import {route} from "preact-router";
import {api} from "../../../../services";
import axios from "axios";
import {useBehavioralContext} from "../../../../contexts";

export const useSearchBar = () => {
    // Stores the default recommended products
    const [recommendedProducts, setRecommendedProducts] = useState([]);
    // State to be used as a flag for when a request is already being processed
    const [hasRequest, setHasRequest] = useState(null);

    // Retrieves the search bar action stuff.
    // There's no problem to return them from the controller instead from the view,
    // as that's what we've been doing so far.
    // It's just a different approach.
    const {
        searchBarData,
        handleSearchBar
    } = useBehavioralContext();

    // Ref to blur the input if a submission is performed
    const inputRef = useRef(null);

    // Backend call simulation to search for products
    const fetchFilteredProducts = async () => {
        handleSearchBar("data", []);

        // If the query length is under than 3, then it assigns the recommended products as the main list
        // if (!searchBarData["query"].length) {
        //     return;
        // }

        // Checks if there's an ongoing request and, if so, cancels it
        if (hasRequest !== null) {
            hasRequest.cancel();
        }

        // Creates a new unique canceler
        const canceler = axios.CancelToken.source();

        // Sets the canceler to the hasRequest state
        setHasRequest(canceler);

        try {
            // Performs the request to the backend
            let response = await api.get(`/v1/cms/search?q=${searchBarData["query"]}&type=simple`, {
                cancelToken: canceler.token
            });

            // Sets the query results to the filteredProducts state
            handleSearchBar("data", response.data || []);
        } catch (err) {
            // Assigns a null value to the filteredProducts state, just to prevent any unwanted errors
            handleSearchBar("data", []);
        }
    }

    // Backend call simulation to search for the recommended products
    const fetchRecommendedProducts = async () => {
        try {
            // Performs the request to the backend
            let response = await api.get(`/v1/cms/search?q=&pageSize=2&curPage=1`);

            // Appends the response data to the recommended products state
            setRecommendedProducts(response.data.popular);
        } catch (err) {
            console.error('Erro ao buscar os produtos:', err);

            // Assigns an empty array to the recommendedProducts state, just to prevent any unwanted errors
            setRecommendedProducts([]);
        }
    };

    // Method to handle the filter value update
    const handleFilter = e => {
        // Destructured input value
        const {value} = e.target;

        // Sets the filter query to its respective state
        handleSearchBar("query", value);
    }

    // Method to handle the submission
    const handleSubmit = e => {
        // Prevents page from reloading
        e.preventDefault();

        if (searchBarData["query"].length >= 1) {
            // Redirects to the search results page
            route(`/busca?q=${searchBarData["query"]}`);

            // Closes the component
            handleSearchBar("isOpen", false);
        }
    }

    // Effect to trigger the initial fetch products operation
    useEffect(() => {
        fetchFilteredProducts().then(() => {});
    }, [
        searchBarData.query,
        recommendedProducts
    ]);

    // Effect that will be fired immediately when the component is opened to deactivate the body overflow
    useEffect(() => {
        if (searchBarData["isOpen"]) {
            // Deactivates the body overflow
            document.body.classList.add("overflow-deactivate");

            return;
        }

        // Reactivates the body overflow
        document.body.classList.remove("overflow-deactivate");
    }, [searchBarData.isOpen]);

    return {
        searchBarData,
        handleSearchBar,
        handleSubmit,
        handleFilter,
        inputRef
    }
};